var XPortal = XPortal || {};

XPortal.PhoneInput = (function () {
    var self = {
        ControlSelector: '.phone-number-editor',

        LocalizePreffix: "XPortal.Frontend.PhoneInput.",
        LocalizeKeys: {// Aria label for the selected country element, when there is a country selected
            selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
            // Aria label and title text for the selected country element, when no country is selected
            noCountrySelected: "Select country",
            // Aria label for the country list element
            countryListAriaLabel: "List of countries",
            // Placeholder for the search input in the dropdown
            searchPlaceholder: "Search",
            // Aria label for the clear search button
            clearSearchAriaLabel: "Clear search",
            // Visible text for when the search produces no results
            searchEmptyState: "No results found",
            // Screen reader summary of search results
            searchEmptyState: "No results found",
            searchSummary: "${count} results found"
        },
        LocalizationResult: null,
        _localizationPromise: null,

        Init: function (container) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);

            if (!(container && container.length && container[0].id))
                return;

            const modelName = XPortal.Store.getModelName(container[0].id);
            ensureLocalization().then(function () {
                container.find(XPortal.PhoneInput.ControlSelector).each(function (ip, element) {
                    XPortal.PhoneInput.InitFor(modelName, $(element));
                });
            });
        },
        InitFor: initFor,
        GetValue: function (el, sttgs) {
            const ctrol = el ? el.data("_intlTelInput") : null;
            const cval = ctrol ? ctrol.getNumber() : el.val();
            return cval;
        },
        SetValue: function (el, sttgs, val) {
            const ctrol = el ? el.data("_intlTelInput") : null;
            if (el && ctrol) {
                if (XPortal.DefaultEditor.IsModified(el, self.GetValue(el, sttgs))) return;
                ctrol.setNumber(val);
            }
            updateInputWithVal(el, sttgs, val);
        },
    };

    function updateInputWithVal(el, sttgs, val) {
        el.val(val);
        el.data("_intlTelInput").setNumber(val);
    };

    function initFor(modelName, element, isInlineEditor = false) {
        if (element.attr("data-inzed") == "1") return;
        element.attr("data-inzed", "1");

        let { sttgs, inputSttgs } = getSettingsFor(element);
        initEditorItSelf(element, inputSttgs, sttgs);

        element.change(function () {
            const xval = self.GetValue(element);
            updateInputWithVal(element, sttgs, xval);
            XPortal.DefaultEditor.SetModification(element, xval);
            if (!isInlineEditor) {
                element.trigger("dispatchFieldEvent");
            }
        });
        element.bind("dispatchFieldEvent", function (e) {
            var xval = self.GetValue(element);
            if (xval === null) xval = '';
            XPortal.Store.FieldEvent(element, xval, modelName, sttgs);
        });

        XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: element },
            (value) => self.SetValue(element, sttgs, value),
            (value) => self.GetValue(element, sttgs)
        );

    };
    function initEditorItSelf(element, inputSttgs, sttgs) {
        const iti = window.intlTelInput(element[0], inputSttgs);
        element.data("_intlTelInput", iti);
        updateInputWithVal(element, sttgs, sttgs.value);
        adjustAndFixFrontedView(element, inputSttgs, sttgs);

        return true;
    };
    function adjustAndFixFrontedView(element, inputSttgs) {
        // Adjust dropdown position if there is not enough space below the input
        element[0].addEventListener('open:countrydropdown', () => {
            const elRect = element[0].getBoundingClientRect();
            const spaceBelow = window.innerHeight - elRect.bottom;
            const itiId = element.data("_intlTelInput").id;
            const dropdown = document.querySelector(`#iti-${itiId}__dropdown-content`);

            if (spaceBelow < 300) {
                dropdown.classList.add('drop-up');
            }
        });

        // Fix known issue with dropdown not closing 
        // when input is in a modal and modal is scrolled
        if (inputSttgs.modalMode) {
            const modalBody = element[0].closest('.modal-body');
            modalBody?.addEventListener('scroll', () => {
                const dropdown = document.querySelector('.iti__country-list');
                if (dropdown) modalBody.click();
            }, { passive: true });
        }

        // Prevent focus trap in modals when country dropdown is open
        element[0].addEventListener('open:countrydropdown', () => {
            $(document).off('focusin.bs.modal');
        });

        element[0].addEventListener('close:countrydropdown', () => {
            const modal = element[0].closest('.modal');
            if (modal) {
                $(modal).data('bs.modal')._enforceFocus();
            }
        });

        const selectedCode = $('.iti__selected-dial-code');
        const selectedCodeLength = selectedCode.text().trim().length;
        console.log('selectedCodeLength', selectedCodeLength);
                
        if (selectedCodeLength > 3) {
            selectedCode.addClass('long-code'); 
        }
        
    };
    function getSettingsFor(element) {
        const es = XPortal.Main.GetSettingsFor(element);
        element.attr("data-sttgs", "");

        const r = es.sttgs = XPortal.Utils.readJsonStr(es.sttgs, {});
        const inModal = element.closest('.modal-dialog').length > 0;
        const pholder = (r.pholder || "").replaceAll("[[item.", "[[").replaceAll("{{item.", "[[").replaceAll("{{", "[[").replaceAll("}}", "]]");

        const s = {
            excludeCountries: ensureInTheList(r.countries.blocked || [], ['ru', 'by']),
            countryOrder: ensureInTheList(r.countries.top || [], [r.countries.initial]),
            onlyCountries: ensureInTheList(r.countries.allowed || []),
            separateDialCode: true,
            formatAsYouType: true,
            formatOnDisplay: true,
            nationalMode: true,
            strictMode: true,
            dropdownContainer: document.body,
            modalMode: inModal,
            i18n: Object.assign({
                searchSummaryAria(count) {
                    return self.searchSummary ? self.searchSummary.replaceAll("${count}", count) : "";
                }
            }, self.LocalizationResult.localizedTexts),
            customPlaceholder: function (selCPlaceholder, selCData) {
                const item = { raw: selCPlaceholder };
                item.phone = item.number = item.example = r.pholderSymbol
                    ? (selCPlaceholder || "").replaceAll(/[\d]/gm, r.pholderSymbol)
                    : item.raw;
                if (pholder && pholder.length > 1) return XPortal.Template.TemplateToHtml(item, pholder);
                return item.phone;
            }
        };

        const myCountryOrder = s.countryOrder;
        const lastCountryCode = myCountryOrder[myCountryOrder.length - 1];

        XPortal.Utils.waitFor(function () {
            const lastCountryElem = document.querySelector(`.iti__country[data-country-code="${lastCountryCode}"]`);
            if (!lastCountryElem) return false;
            lastCountryElem.classList.add('iti__preferred-last');
            return true;
        }, XPortal.Utils.waitFor, 100, 50);

        s.initialCountry = calcInitialCountry(s, es);
        if (r.allowGeo) s.geoIpLookup = (success, failure) => { fetchCurrentLocation(r, success, failure, es); };

        return { sttgs: es, inputSttgs: s };
    };
    function ensureInTheList(src, ext) {
        if (src == null) src = [];
        if (ext == null) return src;
        ext.forEach(x => {
            if (x) {
                if (src.find(ix => ix == x) == null) src.push(x);
            }
        });
        return src;
    };
    function calcInitialCountry(editorSttgs, allSttgs) {
        const r = allSttgs.sttgs;

        if ((allSttgs.value || "").length > 0 && allSttgs.value.substring(0, 1) == "+") {
            r.countries.initial = '';
            return 'auto';
        }

        let initial = (r.countries.initial != null) ? r.countries.initial.trim() : "";
        //if (initial.length < 1 && editorSttgs.countryOrder.length)
        //    initial = editorSttgs.countryOrder[0] || "";

        //if (initial.length < 1 && editorSttgs.onlyCountries.length)
        //    initial = editorSttgs.onlyCountries[0] || "";

        r.countries.initial = initial;
        return initial && initial.length ? initial : "auto";
    };

    function fetchCurrentLocation(r, onSuccess, onFailure, sttgs) {
        if (!r.currentCountryData) r.currentCountryData = r.countries.initial;

        if (r.allowGeo) {
            fetch("https://ipapi.co/json").then(res => res.json())
                .then(data => {
                    onSuccess(r.currentCountryData = data.country_code || r.countries.initial);
                })
                .catch(() => onFailure());
        } else
            onSuccess(r.currentCountryData);
    };
    function ensureLocalization() {
        if (!self._localizationPromise) {
            self._localizationPromise = XPortal.Localization.EnsureLocalizedTexts(self.LocalizePreffix, self.LocalizeKeys)
                .then(function (result) {
                    self.LocalizationResult = result;
                    return result;
                })
                .catch(function (error) {
                    self._localizationPromise = null;
                    throw error;
                });
        }

        return self._localizationPromise;
    }
    return self;
})();
